export async function loadCustomTranslations(locale: string) {
    try {
        return await import(`./translations/compiled/${locale}.json`);
    } catch (error) {
        return import('./translations/compiled/en.json');
    }
}
